module.exports = __webpack_public_path__ + "static/media/kb-article.034f99d6.jpg";